import * as d3 from 'd3';
export function drawFrame(svg, frameType = 1, x, y, width, height, delta, lsize, rsize, 
                          overallHeight, grillsCol = 1, grillsRow = 1, doorColor = 'grey', glassColor = 'white', k=1)
{
    //k = 2;
    let opacity = 0.5;
    let parameters = {}; 
    
    //draw overall height...
    drawRect(svg, x,y, lsize + width + rsize, overallHeight, 0, 'lightgrey', 1, k, 0);
    const innerOverallHeight = drawRect(svg, x,y, lsize + width + rsize, overallHeight, 6, 'white'    , 1, k, 1);
    drawGradient(svg, innerOverallHeight.x, innerOverallHeight.y, innerOverallHeight.width, innerOverallHeight.height, 0.5);

    //draw overall height...
                      drawRect(svg, x,y + k*overallHeight - delta, lsize + width + rsize, height, 0, 'lightgrey', 1, k);
    const innerRect = drawRect(svg, x,y + k*overallHeight - delta, lsize + width + rsize, height, 6, 'white', 0.8, k, 0); //frame
    const widthN = lsize + width + rsize;
 
    const w1 = (lsize* (widthN * k - 2 * delta))/(lsize + width + rsize);
    const w2 = (width* (widthN * k - 2 * delta))/(lsize + width + rsize);
    const w3 = (rsize* (widthN * k - 2 * delta))/(lsize + width + rsize);
  
    const innerRect1 = drawRect(svg, innerRect.x,           innerRect.y, w1 , innerRect.height, 0, 'black', 0, 1, 1);
    //let innerRect2 = drawRect(svg, innerRect.x + w1,      innerRect.y, w2 , innerRect.height, delta, 'lightgrey', 1, 1);
    const innerRect3 = drawRect(svg, innerRect.x + w1 + w2, innerRect.y, w3 , innerRect.height, 0, 'black', 0, 1, 1);

    if (frameType === 1) { // Single door
        let innerRect2 = drawRect(svg, innerRect.x + w1 + delta/4,innerRect.y, w2 , innerRect.height, delta, doorColor, 1, 1);
        const singleDoor = {'single' : innerRect2}
        const side = drawRect(svg,innerRect2.x,                              
                            innerRect2.y, 
                            innerRect2.width + 0, //delta/2, 
                            innerRect2.height, 
                            delta+2, glassColor, 1, 1, 1); //frame
        drawGradient(svg, side.x, side.y, side.width, side.height, 0.5);
        drawGrills(svg,  side.x, side.y, side.width + 16/* 2*delta*/, side.height - delta/2 - 2, grillsCol, grillsRow, 1, 'lightgrey')
    }
    else { //double door
        let innerRect2 = drawRect(svg, innerRect.x + w1, innerRect.y, w2 , innerRect.height, delta, doorColor, 1, 1);
        //drawLine(svg, innerRect.x + w2, innerRect2.y, innerRect.x + w2 , innerRect2.y+innerRect2.height - delta/2 + 2,
        //              1, doorColor, 'regular');  
  
        const leftSide = drawRect(svg,innerRect2.x,                              
                                      innerRect2.y, 
                                      innerRect2.width/2 + delta/2, 
                                      innerRect2.height, 
                                      delta+2, glassColor, 1, 1, 1); //frame
        drawGradient(svg, leftSide.x, leftSide.y, leftSide.width, leftSide.height, 0.5);
        const rightSide = drawRect(svg, innerRect2.x + innerRect2.width/2 - delta/2,
                                      innerRect2.y, 
                                      innerRect2.width/2 + delta/2, 
                                      innerRect2.height, 
                                      delta+2, glassColor, 1, 1, 1); //frame
        drawGradient(svg, rightSide.x, rightSide.y, rightSide.width, rightSide.height, 0.5);                    
        parameters.double = {'leftSide' : leftSide, 'rightSide' : rightSide}
        drawGrills(svg,  leftSide.x,  leftSide.y,  leftSide.width  + 16/* 2*delta*/, leftSide.height  - delta/2 - 2, grillsCol, grillsRow, 1, 'lightgrey')
        drawGrills(svg,  rightSide.x, rightSide.y, rightSide.width + 16/* 2*delta*/, rightSide.height - delta/2 - 2, grillsCol, grillsRow, 1, 'lightgrey')
    }   
}
function drawLine(svg, x1, y1, x2, y2, thickness, color, type /* 'regular' or 'dotted' */) {
    svg.append('line')
        .attr('x1', x1)
        .attr('y1', y1)
        .attr('x2', x2)
        .attr('y2', y2)
        .attr('stroke', color) // Use the provided color
        .attr('stroke-width', thickness) // Set the line thickness
        .attr('stroke-dasharray', type === 'dotted' ? '6, 4' : null); // Apply dashed pattern if dotted
}

export function drawGradient(svg, innerX, innerY,  innerWidth, innerHeight, opacity = 0)
{
            // Create a unique ID for the gradient
            const gradientId = 'gradientBottomToTop';

            // Define a linear gradient (bottom to top)
            const defs = svg.append('defs');
            const linearGradient = defs.append('linearGradient')
                .attr('id', gradientId)
                .attr('x1', '0%') // Start at the bottom
                .attr('y1', '100%') // Bottom
                .attr('x2', '0%') // End at the top
                .attr('y2', '0%'); // Top
    
                // Define gradient stops
                linearGradient.append('stop')
                .attr('offset', '0%')
                .attr('stop-color', 'lightblue');
                linearGradient.append('stop')
                .attr('offset', '100%')
                .attr('stop-color', 'white');
    
                // Append the rectangle to the SVG with gradient fill
                svg.append('rect')
                .attr('x', innerX)
                .attr('y', innerY)
                .attr('width', innerWidth)
                .attr('height', innerHeight)
                .attr('stroke', 'lightgrey') // Set border color to black
                .attr('stroke-width', 2) // Set border thickness (adjust as needed)
                .attr('fill', `url(#${gradientId})`) // Use the gradient as fill
                .attr('fill-opacity', opacity);
    
}
export function applyImageRegular(svg, rectX,  rectY, rectWidth, rectHeight, 
    imageLink = "https://cdn.indikor.com/bdb4fc59-8372-4282-9e32-485b838a60ff", clipId = "clip-rect" )
{
    // Add the image and clip it
    svg.append("clipPath")
    .attr("id", clipId)
    .append("rect")
    .attr("x", rectX)
    .attr("y", rectY)
    .attr("width", rectWidth)
    .attr("height", rectHeight);

    svg.append("image")
    .attr("href", imageLink)
    .attr("x", rectX)
    .attr("y", rectY)
    .attr("width", rectWidth)
    .attr("height", rectHeight)
    .attr("clip-path", `url(#${clipId})`)
    .attr("preserveAspectRatio", "xMidYMid slice");
}

export function applyImage(svg, rectX, rectY, rectWidth, rectHeight, 
    imageLink = "https://cdn.indikor.com/bdb4fc59-8372-4282-9e32-485b838a60ff", 
    fitMode = "stretch", clipId = "clip-rect") {
    // Add the clip path with a unique ID
    svg.append("clipPath")
        .attr("id", clipId) // Use the provided clipId
        .append("rect")
        .attr("x", rectX)
        .attr("y", rectY)
        .attr("width", rectWidth)
        .attr("height", rectHeight);

    // Create the image element
    const image = svg.append("image")
        .attr("href", imageLink)
        .attr("x", rectX)
        .attr("y", rectY)
        .attr("clip-path", `url(#${clipId})`); // Reference the unique clipId

    // Apply different fitting modes
    switch(fitMode.toLowerCase()) {
        case "stretch":
            image.attr("width", rectWidth)
                .attr("height", rectHeight)
                .attr("preserveAspectRatio", "none");
            break;
        case "fit":
            image.attr("width", rectWidth)
                .attr("height", rectHeight)
                .attr("preserveAspectRatio", "xMidYMid meet");
            break;
        case "fill":
            image.attr("width", rectWidth)
                .attr("height", rectHeight)
                .attr("preserveAspectRatio", "xMidYMid slice");
            break;
        default:
            image.attr("width", rectWidth)
                .attr("height", rectHeight)
                .attr("preserveAspectRatio", "none");
    }
}
export function applyImage1(svg, rectX, rectY, rectWidth, rectHeight, imageLink = "https://cdn.indikor.com/bdb4fc59-8372-4282-9e32-485b838a60ff", fitMode = "stretch") {
    // Add the clip path
    svg.append("clipPath")
        .attr("id", "clip-rect")
        .append("rect")
        .attr("x", rectX)
        .attr("y", rectY)
        .attr("width", rectWidth)
        .attr("height", rectHeight);

    // Create the image element
    const image = svg.append("image")
        .attr("href", imageLink)
        .attr("x", rectX)
        .attr("y", rectY)
        .attr("clip-path", "url(#clip-rect)");

    // Apply different fitting modes
    switch(fitMode.toLowerCase()) {
        case "stretch": // Ignores aspect ratio, fills entire rectangle
            image.attr("width", rectWidth)
                .attr("height", rectHeight)
                .attr("preserveAspectRatio", "none");
            break;

        case "fit": // Maintains aspect ratio, fits within rectangle
            image.attr("width", rectWidth)
                .attr("height", rectHeight)
                .attr("preserveAspectRatio", "xMidYMid meet");
            break;

        case "fill": // Maintains aspect ratio, fills rectangle (may crop)
            image.attr("width", rectWidth)
                .attr("height", rectHeight)
                .attr("preserveAspectRatio", "xMidYMid slice");
            break;

        default: // Default to stretch
            image.attr("width", rectWidth)
                .attr("height", rectHeight)
                .attr("preserveAspectRatio", "none");
    }
}

export function applyImageHeight(svg, rectX, rectY, rectWidth, rectHeight, imageLink = "https://cdn.indikor.com/bdb4fc59-8372-4282-9e32-485b838a60ff") {
    // Add the image and clip it
    svg.append("clipPath")
        .attr("id", "clip-rect")
        .append("rect")
        .attr("x", rectX)
        .attr("y", rectY)
        .attr("width", rectWidth)
        .attr("height", rectHeight);

    svg.append("image")
        .attr("href", imageLink)
        .attr("x", rectX)
        .attr("y", rectY)
        .attr("width", rectWidth) // Set width independently
        .attr("height", rectHeight) // Set height independently
        .attr("clip-path", "url(#clip-rect)"); // No preserveAspectRatio
}


export function drawRect(svg, x1, y1, width, height, delta = 0, color = 'grey', opacity = 0, k = 1, gradient = 0) {
    // Calculate inner rectangle properties
    const innerX = x1 + delta;
    const innerY = y1 + delta;
    const innerWidth = width * k - 2 * delta;
    const innerHeight = height * k - 2 * delta;

    // Append the rectangle to the SVG
    svg.append('rect')
        .attr('x', innerX)
        .attr('y', innerY)
        .attr('width', innerWidth)
        .attr('height', innerHeight)
        .attr('stroke', 'black') // Set border color to black
        .attr('stroke-width', 0) // Set border thickness (adjust as needed)
        .attr('fill', color)
        .attr('fill-opacity', opacity);

    if (0) {//(gradient === 1) {
        // Create a unique ID for the gradient
        const gradientId = 'gradientBottomToTop';

        // Define a linear gradient (bottom to top)
        const defs = svg.append('defs');
        const linearGradient = defs.append('linearGradient')
            .attr('id', gradientId)
            .attr('x1', '0%') // Start at the bottom
            .attr('y1', '100%') // Bottom
            .attr('x2', '0%') // End at the top
            .attr('y2', '0%'); // Top

            // Define gradient stops
            linearGradient.append('stop')
            .attr('offset', '0%')
            .attr('stop-color', 'lightblue');
            linearGradient.append('stop')
            .attr('offset', '100%')
            .attr('stop-color', 'white');

            // Append the rectangle to the SVG with gradient fill
            svg.append('rect')
            .attr('x', innerX)
            .attr('y', innerY)
            .attr('width', innerWidth)
            .attr('height', innerHeight)
            .attr('stroke', 'black') // Set border color to black
            .attr('stroke-width', 2) // Set border thickness (adjust as needed)
            .attr('fill', `url(#${gradientId})`) // Use the gradient as fill
            .attr('fill-opacity', opacity);
    }
    // Return the dimensions of the inner rectangle
    return { x: innerX, y: innerY, width: innerWidth, height: innerHeight };
}

export function drawRect1(svg, x1,y1, width, height, delta = 0, color = 'grey', opacity = 0, k=1)
{
    svg.append('rect') 
    .attr('x', x1 + delta)
    .attr('y', y1 + delta)
    .attr('width', width*k  - 2*delta )
    .attr('height', height*k - 2*delta)
    .attr('stroke', 'black') // Set border color to black
    .attr('stroke-width', 2) // Set border thickness (adjust as needed)
    .attr('stroke', 'lightgrey')
    .attr('fill', color)
    .attr('fill-opacity', opacity);
}
export function paintSill(svg, width, height, frameWidth, color = 'lightgrey')
{
    if (true) { return;}
    svg.append('rect') //bottom horizontal
    .attr('x', 0)
    .attr('y', height + 2*frameWidth + 2)
    .attr('width', 2*frameWidth + 2  + width)
    .attr('height',0 + 2*frameWidth + 2)
    .attr('fill', color); 
}

export function drawGrills(svg, x, y, width, height, cols, rows, k, color = 'lightgrey')
{
    width = width - 2*8;
    //height = height - 20;

    if (cols > 0){
        for (var i = 0; i < cols - 1; i++) {
            let rect = svg.append('rect') //left vertical
            .attr('x', x + 4 + (i+1)*k*width/cols - k*8)
            .attr('y', y + 0)
            .attr('width',   4)
            .attr('height', k*height + 4)
            .attr('fill', color) 
            //.attr('stroke', 'black')         // Border color (you can use any color)
            .attr('stroke-width', 0.5);        // Border thickness in pixels
            if (color === 'white') {
                rect.attr('stroke', 'black');
            }
        }
    }
    //rows = 5;
    if (rows > 0){
        for (var i = 0; i < rows - 1; i++) {
            let rect = svg.append('rect') //left vertical
            .attr('x', x + 0)
            .attr('y', y + k*4 + (i+1)*k*height/rows - k*8)
            .attr('width', 0  +  k*(width-8) + k*8)
            .attr('height', 4)
            .attr('fill', color)
            //.attr('stroke', 'black')         // Border color (you can use any color)
            .attr('stroke-width', 0.5);        // Border thickness in pixels 
            if (color === 'white') {
                rect.attr('stroke', 'black');
            }
        }
    }
}

export function paintOuterFrame(svg, width, height, frameWidth, overallHeight, color = 'lightgrey')
{
    svg.append('rect') //left vertical
    .attr('x', 0)
    .attr('y', 0)
    .attr('width', 2*frameWidth + 2)
    .attr('height', height + 2*frameWidth + 2)
    .attr('fill', color); 

    svg.append('rect') //right vertical
    .attr('x', width -(2*frameWidth + 2) + 2 )
    .attr('y', 0)
    .attr('width', width + 2*frameWidth + 2  + 2*frameWidth + 2)
    .attr('height', height + 2*frameWidth + 2)
    .attr('fill', color); 

    svg.append('rect') //top horizontal
    .attr('x', 0)
    .attr('y', 0)
    .attr('width', 2*frameWidth + 2  + width)
    .attr('height',0 + 2*frameWidth + 2)
    .attr('fill', color);

    svg.append('rect') //bottom horizontal
    .attr('x', 0)
    .attr('y', height + 2*frameWidth + 2 )
    .attr('width', 2*frameWidth + 2  + width)
    .attr('height',0 + 2*frameWidth + 2)
    .attr('fill', color); 

    if (overallHeight > 0) {
        svg.append('rect') //top horizontal
        .attr('x', 0)
        .attr('y', overallHeight)
        .attr('width', 2*frameWidth + 2  + width)
        .attr('height',0 + 2*frameWidth + 2 )
        .attr('fill', color);
    }
    //drawGrills(svg, width, height, 1, 1);
    return svg;
}
export function create_svg(w, h)
{
// Create an empty SVG element
const svg = d3.select('body') // Attach to the body or another container
    .append('svg') // Create the <svg> element
    .attr('width', w) // Set the width
    .attr('height', h) // Set the height
    .style('border', '1px solid black'); // Optional: Add a border for visibility
    return svg;
}
